export enum RewardsType {
  FIRST_LOGIN = "firstLogin",
  SHOW_INTEREST_IN_RENEWAL = "showInterestInRenewal",
  EARLY_LEASE_RENEWAL = "earlyLeaseRenewal",
  EARLY_PAYMENT = "earlyPayment",
  ON_TIME_PAYMENT = "onTimePayment",
}
